import React, { useEffect, useState } from "react";

function Filter({ data, filter, isMobile, setpage, setfilter }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [counties, setcounties] = useState([]);
  // const [selectedCounty, setSelectedCounty] = useState([]);
  const [countySearch, setCountySearch] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [selectedcounty, setSelectedcounty] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedproduce, setSelectedproduce] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [changestate, setchangestate] = useState("");

  const handleproductChange = (value, type) => {
    if (type === "product") {
      setSelectedProducts((prev) =>
        prev.includes(value)
          ? prev.filter((product) => product !== value)
          : [...prev, value]
      );
    }
  };
  const handlepurchaseChange = (value, type) => {
    if (type === "product") {
      setSelectedproduce((prev) =>
        prev.includes(value)
          ? prev.filter((product) => product !== value)
          : [...prev, value]
      );
    }
  };

  const handleCountyChange = (county) => {
    if (selectedcounty.includes(county)) {
      setSelectedcounty(
        selectedcounty.filter((selected) => selected !== county) // Remove if already selected
      );
    } else {
      setSelectedcounty([...selectedcounty, county]); // Add to array if not selected
    }
  };

  const [selectedEquipment, setSelectedEquipment] = useState([]);
  // useEffect(() => {
  //   const fetchCounties = async () => {
  //     try {
  //       const response = await fetch(
  //         "https://gist.githubusercontent.com/vitalii-z8i/bbb96d55d57f1e4342c3408e7286d3f2/raw/3b9b1fba8b226359d5a025221bb2688e9807c674/counties_list.json"
  //       );
  //       const data = await response.json();

  //       const californiaCounties = data.filter(
  //         (county) => county.State === "California"
  //       );

  //       const options = californiaCounties.map((county) => ({
  //         value: county.County.replace(" County", ""),
  //         label: county.County.replace(" County", ""),
  //       }));

  //       setcounties(options);
  //     } catch (error) {
  //       console.error("Error fetching counties:", error);
  //     }
  //   };

  //   fetchCounties();
  // }, []);
  const equipmentOptions = data?.equipments || [];

  const handleCheckboxChange = (value) => {
    setSelectedEquipment((prev) =>
      prev.includes(value)
        ? prev.filter((equipment) => equipment !== value)
        : [...prev, value]
    );
  };

  const [selectedResidue, setSelectedResidue] = useState([]);
  const [selectedCerti, setSelectedCerti] = useState([]);
  const filteredEquipment = equipmentOptions.filter((equipment) =>
    equipment.toLowerCase().includes(searchQuery.toLowerCase())
  );
  // const filteredCounty = counties?.value.filter((county) =>
  //   // typeof county === "string" &&
  //   county.toLowerCase().includes(searchQuery.toLowerCase())
  // );

  const [selectedspecies, setSelectedspecies] = useState([]);
  const speciesOptions = [
    ...(data?.species["Softwoods"] || []),
    ...(data?.species["Hardwoods"] || []),
  ];

  const handleChangespecies = (value) => {
    setSelectedspecies((prev) =>
      prev.includes(value)
        ? prev.filter((pecies) => pecies !== value)
        : [...prev, value]
    );
  };
  const filteredspecies = speciesOptions.filter((species) =>
    species.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const productdata = [
    ...(data?.wood_products["Non-timber and Special Forest Products"] || []),
    ...(data?.wood_products["Timber Products"] || []),
  ];

  const filteredProducts = productdata
    ?.filter((product) =>
      product?.toLowerCase().includes(searchQuery?.toLowerCase())
    )
    .sort();

  const filteredPurchasedProducts = productdata
    ?.filter((product) =>
      product?.toLowerCase().includes(searchQuery?.toLowerCase())
    )
    .sort();
  const residueOptions = data?.residue || [];
  const certificateOptions = data?.certifications || [];
  const handleChangeresidue = (value) => {
    setSelectedResidue((prev) =>
      prev.includes(value)
        ? prev.filter((residue) => residue !== value)
        : [...prev, value]
    );
  };
  const handleChangecertificate = (value) => {
    setSelectedCerti((prev) =>
      prev.includes(value)
        ? prev.filter((certi) => certi !== value)
        : [...prev, value]
    );
  };

  const filteredResidue = residueOptions.filter((residue) =>
    residue.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const filteredCertificate = certificateOptions.filter((certi) =>
    certi.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const serviceOptions = [
    ...(data?.services["Forestry Services"] || []),
    ...(data?.services["Manufacturing / Secondary manufacturing"] || []),
  ];

  const handleChangeservice = (value) => {
    setSelectedServices((prev) =>
      prev.includes(value)
        ? prev.filter((service) => service !== value)
        : [...prev, value]
    );
  };

  const filteredCounties = counties.filter((county) =>
    county.label.toLowerCase().includes(countySearch.toLowerCase())
  );
  const filteredServices = serviceOptions.filter((service) =>
    service.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const [selectedServices, setSelectedServices] = useState([]);

  const handleInputChange = (event) => {
    setCompanyName(event.target.value);
  };

  const [acceptsBigLogs, setAcceptsBigLogs] = useState("");

  const applyFilter = () => {
    const filterData = {
      products_produced: selectedProducts,
      products_purchased: selectedproduce,
      company_name: companyName,
      region: setfilter ? combinedSelection : selectedAreas,
      equipments: selectedEquipment,
      services: selectedServices,
      species: selectedspecies,
      accept_bid_logs: acceptsBigLogs,
      certifications: selectedCerti,
      state: changestate,
    };
    filter(filterData);
    setpage(1);
  };
  const handleclear = () => {
    setSelectedProducts([]);
    setSelectedproduce([]);
    setCompanyName("");
    setSelectedcounty([]);
    setSelectedEquipment([]);
    setSelectedServices([]);
    setAcceptsBigLogs("");
    setSelectedCerti([]);
    setSelectedAreas([])
    setchangestate("");
    setSelectedspecies([])
    filter();
  };
  const states = ["California", "Nevada", "Oregon"];

  const [selectedAreas, setSelectedAreas] = useState([]); // Tracks selected areas

  const handleRegionSelect = (regionName, areas) => {
    const allSelected = areas.every((area) => selectedAreas.includes(area));

    setSelectedAreas((prevSelectedAreas) => {
      if (areas.length === 0) {
        // Toggle regionName in selectedAreas
        return prevSelectedAreas.includes(regionName)
          ? prevSelectedAreas.filter((item) => item !== regionName)
          : [...prevSelectedAreas, regionName];
      } else {
        // Handle areas logic
        return allSelected
          ? prevSelectedAreas.filter((area) => !areas.includes(area)) // Deselect all areas in the region
          : [
            ...prevSelectedAreas,
            ...areas.filter((area) => !prevSelectedAreas.includes(area)),
          ]; // Select all areas in the region
      }
    });
  };

  const handleAreaSelect = (area) => {
    const alreadySelected = selectedAreas.includes(area);

    setSelectedAreas(
      (prevSelectedAreas) =>
        alreadySelected
          ? prevSelectedAreas.filter((a) => a !== area) // Deselect the area
          : [...prevSelectedAreas, area] // Select the area
    );
  };

  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedAreas1, setSelectedAreas1] = useState([]);

  const combinedSelection = selectedRegion
    ? [selectedRegion, ...selectedAreas1]
    : [...selectedAreas1];

  useEffect(() => {
    applyFilter(selectedRegion, selectedAreas1);
  }, [selectedRegion, selectedAreas1]);

  const handleRegionSelect1 = (regionName) => {
    const allCounties = data.region[regionName] || [];
    setSelectedRegion(regionName);
    setSelectedAreas1(allCounties);
  };

  const handleAreaSelect1 = (area) => {
    if (area === "") {
      setSelectedAreas1(data.region[selectedRegion] || []);
    } else {
      setSelectedAreas1((prevSelected) => {
        if (prevSelected.length === data.region[selectedRegion]?.length) {
          return [area];
        }

        return prevSelected.includes(area)
          ? prevSelected.filter((a) => a !== area)
          : [area];
      });
    }
  };


  return (
    <>
      {setfilter === true ?
        <>
          <div style={{ display: "flex", gap: "10px" }}>
            <div className={`col-4 ${isMobile ? "margin-left-1em" : "companies-detail"}`} style={{ marginBottom: "0.5em" }}>
              <label htmlFor="region">Region</label>
              <div className="dropdown">
                <button
                  className="form-control eq-down1"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{
                    textAlign: "left",
                    width: "19em",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {selectedRegion || "All Regions"}
                </button>
                <ul className="dropdown-menu">
                  {/* All Regions Option */}
                  <li>
                    <button className="dropdown-item" onClick={() => handleRegionSelect1('')}>
                      All Regions
                    </button>
                  </li>
                  {/* Dynamic Region Options */}
                  {data?.region &&
                    Object.keys(data.region).map((regionName) => (
                      <li key={regionName}>
                        <button className="dropdown-item" onClick={() => handleRegionSelect1(regionName)}>
                          {regionName}
                        </button>
                      </li>
                    ))}
                </ul>
              </div>
            </div>

            {selectedRegion && selectedRegion !== "All Regions" && data.region[selectedRegion]?.length > 0 && (
              <div className={`col-4 ${isMobile ? "margin-left-1em" : "companies-detail"}`} style={{ marginBottom: "0.5em" }}>
                <label htmlFor="county">County</label>
                <div className="dropdown">
                  <button
                    className="form-control eq-down1"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{
                      textAlign: "left",
                      width: "19em",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {selectedAreas1.length === data.region[selectedRegion]?.length ? "All Counties" : selectedAreas1.join(", ")}
                  </button>
                  <ul className="dropdown-menu" style={{ paddingLeft: "15px" }}>
                    {/* All Counties Option */}
                    <li>
                      <button className="dropdown-item" onClick={() => handleAreaSelect1('')}>
                        All Counties
                      </button>
                    </li>
                    {/* Dynamic Counties List */}
                    {data.region[selectedRegion].map((area) => (
                      <div
                        style={{ marginBottom: "0.5em", display: "flex", alignItems: "center" }}
                        key={area}
                      >
                        <li key={area}>
                          <button className="dropdown-item" onClick={() => handleAreaSelect1(area)}>
                            {area}
                          </button>
                        </li>
                      </div>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </>
        : <>
          <div
            className={`col-12 ${isMobile ? "margin-left-1em" : "companies-detail"
              }`}
            style={{ marginBottom: "0.5em" }}
          >
            <label htmlFor="county">Companies that buy</label>
            <div className="dropdown">
              <button
                className="form-control eq-down"
                type="button"
                id="productsProducedDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  textAlign: "left", // Set the fixed width for the button
                  whiteSpace: "nowrap", // Ensure the text doesn't wrap
                  overflow: "hidden", // Hide the overflowing text
                  textOverflow: "ellipsis",
                }}
              >
                {selectedProducts?.length > 0
                  ? selectedProducts.join(", ")
                  : "Select Products"}
              </button>

              <ul
                className="dropdown-menu pl-2"
                aria-labelledby="productsProducedDropdown"
                style={{ width: "19em" }}
              >
                <li className="px-2">
                  <input
                    type="text"
                    style={{ borderColor: "lightgrey" }}
                    className="form-control mb-2"
                    placeholder="Search Companies That Buy..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </li>
                {filteredProducts?.map((product, index) => (
                  <li key={index} className="px-2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`produced-${index}`}
                        value={product}
                        checked={selectedProducts.includes(product)}
                        onChange={() => handleproductChange(product, "product")}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`produced-${index}`}
                      >
                        {product}
                      </label>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div
            className={`col-12 ${isMobile ? "margin-left-1em" : "companies-detail"
              }`}
            style={{ marginBottom: "0.5em" }}
          >
            <label htmlFor="county">Companies that sell</label>
            <div className="dropdown">
              <button
                className="form-control eq-down"
                type="button"
                id="productsPurchasedDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  textAlign: "left", // Set the fixed width for the button
                  whiteSpace: "nowrap", // Ensure the text doesn't wrap
                  overflow: "hidden", // Hide the overflowing text
                  textOverflow: "ellipsis",
                }}
              >
                {selectedproduce.length > 0
                  ? selectedproduce.join(", ")
                  : "Select Products"}
              </button>
              <ul
                className="dropdown-menu pl-2"
                aria-labelledby="productsPurchasedDropdown"
                style={{ width: "19em" }}
              >
                <li className="px-2">
                  <input
                    type="text"
                    style={{ borderColor: "lightgrey" }}
                    className="form-control mb-2"
                    placeholder="Search Companies That Sell..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </li>

                {filteredPurchasedProducts?.map((product, index) => (
                  <li key={index} className="px-2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`purchased-${index}`}
                        value={product}
                        checked={selectedproduce.includes(product)}
                        onChange={() => handlepurchaseChange(product, "product")}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`purchased-${index}`}
                      >
                        {product}
                      </label>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div
            className={`col-12 ${isMobile ? "margin-left-1em" : "companies-detail"
              }`}
            style={{ marginBottom: "0.5em" }}
          >
            <label htmlFor="county">Services</label>
            <div className="dropdown">
              <button
                className="form-control eq-down"
                type="button"
                id="servicesDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  textAlign: "left",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {selectedServices.length > 0
                  ? selectedServices.join(", ")
                  : "Select Services"}
              </button>
              <ul
                className="dropdown-menu pl-2"
                aria-labelledby="servicesDropdown"
                style={{ width: "19em" }}
              >
                <li className="px-2">
                  <input
                    style={{ borderColor: "lightgray" }}
                    type="text"
                    className="form-control mb-2"
                    placeholder="Search services..."
                    onChange={(e) => setSearchQuery(e.target.value)}
                    value={searchQuery}
                  />
                </li>
                {filteredServices.map((service, index) => (
                  <li key={index} className="px-2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`service-${index}`}
                        value={service}
                        checked={selectedServices.includes(service)}
                        onChange={() => handleChangeservice(service)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`service-${index}`}
                      >
                        {service}
                      </label>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div
            className={`col-12 ${isMobile ? "margin-left-1em" : "companies-detail"
              }`}
            style={{ marginBottom: "0.5em" }}
          >
            <label htmlFor="equipment">Equipment</label>
            <div className="dropdown">
              <button
                className="form-control eq-down"
                type="button"
                id="equipmentDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  textAlign: "left",
                  width: "19em", // Set the fixed width for the button
                  whiteSpace: "nowrap", // Ensure the text doesn't wrap
                  overflow: "hidden", // Hide the overflowing text
                  textOverflow: "ellipsis",
                }}
              >
                {selectedEquipment.length > 0
                  ? selectedEquipment.join(", ")
                  : "Select Equipment"}
              </button>
              <ul
                className="dropdown-menu pl-2"
                aria-labelledby="equipmentDropdown"
                style={{ width: "19em" }}
              >
                <li className="px-2">
                  <input
                    style={{ borderColor: "lightgray" }}
                    type="text"
                    className="form-control mb-2"
                    placeholder="Search equipment..."
                    onChange={(e) => setSearchQuery(e.target.value)}
                    value={searchQuery}
                  />
                </li>
                {filteredEquipment.map((equipment, index) => (
                  <li key={index} className="px-2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`equipment-${index}`}
                        value={equipment}
                        checked={selectedEquipment.includes(equipment)}
                        onChange={() => handleCheckboxChange(equipment)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`equipment-${index}`}
                      >
                        {equipment}
                      </label>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div
            className={`col-12 ${isMobile ? "margin-left-1em" : "companies-detail"
              }`}
            style={{ marginBottom: "0.5em" }}
          >
            <label htmlFor="county">Region</label>
            <div className="dropdown">
              <button
                className="form-control eq-down"
                type="button"
                id="countyDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  textAlign: "left",
                  width: "19em", // Set the fixed width for the button
                  whiteSpace: "nowrap", // Ensure the text doesn't wrap
                  overflow: "hidden", // Hide the overflowing text
                  textOverflow: "ellipsis",
                }}
              >
                {selectedAreas.length > 0
                  ? selectedAreas.join(", ")
                  : "Select Region"}
              </button>
              <ul
                className="dropdown-menu pl-2"
                aria-labelledby="countyDropdown"
                style={{ width: "19em" }}
              >
                {data?.region && Object.keys(data.region).length > 0 && (
                  <div
                    className="d-flex flex-column"
                    style={{ marginLeft: "1em" }}
                  >
                    {Object.entries(data.region).map(([regionName, areas]) => (
                      <div key={regionName} className="d-flex flex-column">
                        {/* Region Checkbox */}
                        <div
                          style={{
                            marginBottom: "0.5em",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={areas.length > 0
                              ? areas.every((area) => selectedAreas.includes(area))
                              : selectedAreas.includes(regionName)
                            }
                            onChange={() => handleRegionSelect(regionName, areas)}
                          />
                          <label
                            className="form-check-label"
                            style={{
                              marginLeft: "0.5em",
                              fontWeight: "bold",
                            }}
                          >
                            {regionName} {areas.length > 0 ? `(all)` : ""}
                          </label>
                        </div>

                        {/* Areas Checkboxes */}
                        <div
                          className="d-flex flex-column"
                          style={{ gap: "0.5em", paddingLeft: "1em" }}
                        >
                          {areas.map((area) => (
                            <div
                              key={area}
                              style={{
                                marginBottom: "0.5em",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={selectedAreas.includes(area)}
                                onChange={() => handleAreaSelect(area)}
                              />
                              <label
                                className="form-check-label"
                                style={{
                                  marginLeft: "0.5em",
                                }}
                              >
                                {area}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </ul>
            </div>
          </div>
          <div
            className={`col-12 ${isMobile ? "margin-left-1em" : "companies-detail"
              }`}
            style={{ marginBottom: "0.5em" }}
          >
            <label htmlFor="companyName">Company Name</label>
            <input
              type="text"
              className="form-control inp-width"
              id="companyName"
              value={companyName}
              onChange={handleInputChange}
              placeholder="Filter by Company Name"
              style={{
                textAlign: "left",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          </div>
          <div
            className={`col-12 ${isMobile ? "margin-left-1em" : "companies-detail"
              }`}
            style={{ marginBottom: "0.5em" }}
          >
            <label htmlFor="county">Species</label>
            <div className="dropdown">
              <button
                className="form-control eq-down"
                type="button"
                id="productsProducedDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  textAlign: "left", // Set the fixed width for the button
                  whiteSpace: "nowrap", // Ensure the text doesn't wrap
                  overflow: "hidden", // Hide the overflowing text
                  textOverflow: "ellipsis",
                }}
              >
                {selectedspecies?.length > 0
                  ? selectedspecies.join(", ")
                  : "Select Species"}
              </button>

              <ul
                className="dropdown-menu pl-2"
                aria-labelledby="productsProducedDropdown"
                style={{ width: "19em" }}
              >
                <li className="px-2">
                  <input
                    type="text"
                    style={{ borderColor: "lightgrey" }}
                    className="form-control mb-2"
                    placeholder="Search Companies That Buy..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </li>
                {filteredspecies?.map((species, index) => (
                  <li key={index} className="px-2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`species-${index}`}
                        value={species}
                        checked={selectedspecies.includes(species)}
                        onChange={() => handleChangespecies(species, "species")}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`produced-${index}`}
                      >
                        {species}
                      </label>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div
            className={`col-12 ${isMobile ? "margin-left-1em" : "companies-detail"
              }`}
            style={{ marginBottom: "0.5em" }}
          >
            <label htmlFor="certification">Certificates</label>
            <div className="dropdown">
              <button
                className="form-control eq-down"
                type="button"
                id="certiDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  textAlign: "left",
                  width: "19em", // Set the fixed width for the button
                  whiteSpace: "nowrap", // Ensure the text doesn't wrap
                  overflow: "hidden", // Hide the overflowing text
                  textOverflow: "ellipsis",
                }}
              >
                {selectedCerti.length > 0
                  ? selectedCerti.join(", ")
                  : "Select Certificates"}
              </button>
              <ul
                className="dropdown-menu pl-2"
                aria-labelledby="certiDropdown"
                style={{ width: "19em" }}
              >
                <li className="px-2">
                  <input
                    style={{ borderColor: "lightgray" }}
                    type="text"
                    className="form-control mb-2"
                    placeholder="Search certificate..."
                    onChange={(e) => setSearchQuery(e.target.value)}
                    value={searchQuery}
                  />
                </li>
                {filteredCertificate.map((certi, index) => (
                  <li key={index} className="px-2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`certi-${index}`}
                        value={certi}
                        checked={selectedCerti.includes(certi)}
                        onChange={() => handleChangecertificate(certi)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`certi-${index}`}
                      >
                        {certi}
                      </label>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div
            className={`col-12 ${isMobile ? "margin-left-1em" : "companies-detail"
              }`}
            style={{ marginBottom: "0.5em" }}
          >
            <label htmlFor="State">State</label>

            <select
              className={"form-select  form-control eq-down"}
              id="state"
              value={changestate}
              onChange={(e) => {
                setchangestate(e.target.value);
              }}
            >
              <option value="" disabled>
                Select State
              </option>
              {states.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>
          <div
            className={`col-12 ${isMobile ? "margin-left-1em" : "companies-detail"
              }`}
            style={{
              marginBottom: "1.5em",
              marginTop: "1.5em",
            }}
          >
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="acceptsBigLogs"
                checked={acceptsBigLogs} // This will be true or false
                onChange={(e) => setAcceptsBigLogs(e.target.checked)} // Set true or false based on checkbox state
              />
              <label
                htmlFor="acceptsBigLogs"
                className="form-check-label"
                style={{ width: "10em" }}
              >
                Accepts Big Logs
              </label>
            </div>
          </div>
        </>}

      {setfilter !== true && <div className="filter-but companies-btn" style={{ marginLeft: "2.5em" }}>
        <button
          type="button"
          onClick={() => handleclear()}
          className="btn btn-primary2"
        >
          Clear
        </button>

        <button
          type="button"
          onClick={() => applyFilter()}
          className="btn btn-primary2"
        >
          Apply Filter
        </button>
      </div>}
    </>
  );
}

export default Filter;
